import {
  Card,
  Grid,
  List,
  ListItem,
  Paper,
  Typography,
  ListItemText,
} from "@material-ui/core";
import {
  CheckBox,
  PhotoCamera,
  SettingsRemote,
  Gesture,
  MenuOpen,
  TextFormat,
  Edit,
  Delete,
} from "@material-ui/icons";
import React from "react";
import { TaskItemInput, TaskItemTypeEnum } from "../TaskItemListAndAdd";
import {
  StandardRowContainer,
  StretchRow,
} from "components/Layout/StandardStyledComponents";
import { useStyles } from "Theme/styles";
import Icon, { IconEnum } from "components/Layout/Icon";
interface TaskItemCardProps {
  taskItem: TaskItemInput;
}

export default function TaskItemCard({ taskItem }: TaskItemCardProps) {
  console.log(
    "🚀 ~ file: TaskItemCard.tsx ~ line 25 ~ TaskItemCard ~ taskItem",
    taskItem
  );
  const classes = useStyles();
  let icon = <div>N/A</div>;
  switch (taskItem.type) {
    case TaskItemTypeEnum.BARCODE:
      icon = <Icon iconEnum={IconEnum.BARCODE} />;
      break;
    case TaskItemTypeEnum.CHECKLIST:
      icon = <Icon iconEnum={IconEnum.CHECKLIST} />;
      break;
    case TaskItemTypeEnum.FORM:
      icon = <Icon iconEnum={IconEnum.FORM} />;
      break;
    case TaskItemTypeEnum.DROPDOWN:
      icon = <Icon iconEnum={IconEnum.DROPDOWN} />;
      break;
    case TaskItemTypeEnum.SIGNATURE:
      icon = <Icon iconEnum={IconEnum.SIGNATURE} />;
      break;
    case TaskItemTypeEnum.TAKE_PHOTO:
      icon = <Icon iconEnum={IconEnum.PHOTO} />;
      break;
  }
  let list;
  if (taskItem.type === TaskItemTypeEnum.DROPDOWN) {
    taskItem.name = "Dropdown";
    list = (
      <List dense={true}>
        {taskItem.options.map((option) => {
          return (
            <ListItem key={option.value}>
              <ListItemText primary={option.label} />
            </ListItem>
          );
        })}
      </List>
    );
  }
  if (taskItem.type === TaskItemTypeEnum.CHECKLIST) {
    taskItem.name = "Checklist";
    list = (
      <List dense={true}>
        {taskItem.options.map((option) => {
          return (
            <ListItem key={option.value}>
              <ListItemText primary={option.label} />
            </ListItem>
          );
        })}
      </List>
    );
  }
  return (
    <Paper className={classes.paperCard}>
      <StandardRowContainer>
        {icon}
        <StretchRow>
          <Typography>{taskItem.name}</Typography>
          {list}
        </StretchRow>
        <Edit />
        <Delete />
      </StandardRowContainer>
    </Paper>
  );
}
